import React, { Component } from 'react';
import { connect } from 'react-redux';
import Downloads from '../../downloads';
import { getActiveProject } from '../../../reducers/mainReducer';
import './StepTakeAction.css';

export class StepTakeAction extends Component {
    render() {
        return (
            <div className="step-action-layout">
                <div className="step-action-info-banner">
                    Download your configured files below. Downloads are only available for the current configuration — if you move on without downloading, you will need to reconfigure to get them again.
                </div>
                <div className="step-action-cards">
                    <div className="step-action-card">
                        <h3>Generate Downloads</h3>
                        <p className="step-action-card-description">
                            Download your configured model in the available file formats. When you are finished, click Next to continue to quote options.
                        </p>
                        <div className="step-action-downloads-container">
                            <Downloads />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

/* istanbul ignore next */
export default connect(function(store) {
    const activeProject = getActiveProject(store);
    return {
        activeProject
    };
})(StepTakeAction);
